export const sourceOptions = [
  { label: "Amigos y familia", value: "FRIENDS_AND_FAMILY" },
  { label: "Capital de riesgo", value: "RISK_CAPITAL" },
  { label: "Inversionista Ángel", value: "ANGEL_INVESTOR" },
  { label: "Bancos e instituciones financieras", value: "BANKS_AND_FINANCIAL_INSTITUTIONS" },
  { label: "Crowdfunding", value: "CROWDFUNDING" },
  { label: "Gobierno", value: "GOVERNMENT" },
  { label: "Otro", value: "OTHER" }
];